export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12150.2a6f3d01.jpg";